function numberToWords(num) {
  if (num === 0) return "zero";

  const belowTwenty = [
    "бир",
    "икки",
    "уч",
    "Тўрт",
    "Беш",
    "Олти",
    "Етти",
    "Саккиз",
    "Тўққиз",
    "Ўн",
    "Ўн бир",
    "Ўн икки",
    "Ўн уч",
    "Ўн тўрт",
    "Ўн беш",
    "Ўн олти",
    "Ўн етти",
    "Ўн саккиз",
    "Ўн тўққиз",
  ];
  const tens = [
    "Йигирма",
    "Ўттиз",
    "Қирқ",
    "Эллик",
    "Олтмиш",
    "Етмиш",
    "Саксон",
    "Тўқсон",
  ];

  const thousands = ["", "Минг"];

  function helper(n) {
    if (n === 0) return "";
    else if (n < 20) return belowTwenty[n - 1] + " ";
    else if (n < 100)
      return tens[Math.floor(n / 10) - 2] + " " + helper(n % 10);
    else
      return belowTwenty[Math.floor(n / 100) - 1] + " Yuz " + helper(n % 100);
  }

  let result = "";
  let thousandCount = 0;

  while (num > 0) {
    if (num % 1000 !== 0) {
      result = helper(num % 1000) + thousands[thousandCount] + " " + result;
    }
    num = Math.floor(num / 1000);
    thousandCount++;
  }

  return result.trim();
}

export default numberToWords;
